"use client";

import { useState, useEffect } from "react-safe";
import { WifiOff } from "lucide-react";
import { cn } from "@/lib/utils";

export function OfflineIndicator() {
  const [isOnline, setIsOnline] = useState(true);
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
    setIsOnline(typeof navigator !== "undefined" ? navigator.onLine : true);

    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (!hasMounted) return null;

  return (
    <div
      className={cn(
        "fixed top-6 left-1/2 z-[9999] flex -translate-x-1/2 items-center gap-2.5 rounded-full bg-destructive/95 px-6 py-3 text-sm font-semibold text-destructive-foreground shadow-2xl backdrop-blur-md transition-all duration-500 ease-in-out border border-white/10",
        isOnline
          ? "-translate-y-24 opacity-0 pointer-events-none"
          : "translate-y-0 opacity-100"
      )}
    >
      <WifiOff className="h-5 w-5 animate-pulse" />
      <span>You have lost network connection. Please check your data.</span>
    </div>
  );
}
